module.exports = __webpack_public_path__ + "img/joinTitP.c40b6e4f.png";